<router-outlet></router-outlet>
<div class="container my-5 text-muted text-center">
  Vaultwarden (unofficial Bitwarden&reg; server)<br />
  {{ "versionNumber" | i18n : version }}
</div>
